module.exports = __webpack_public_path__ + "media/images/design/common/images/btn_volanteer-ec5bf9ff6819cbe17c543d83f76c7404.jpg";